import { WorkspaceDatabaseKeys } from '@database/workspace';
import { CrossFieldValidation } from './cross-field-validation-type';

export class ValidationKeys {
	public static readonly validationTypes = class {
		public static readonly minimumValue = 'min';
		public static readonly maximumValue = 'max';
		public static readonly required = 'required';
		public static readonly noSpecialCharacter = 'no_special_characters';
		public static readonly whitespacesOnlyInTheMiddle = 'whitespacesOnlyInTheMiddle';
		public static readonly decimalPlaces = 'decimal_places';
		public static readonly maximumLength = 'maxlength';
		public static readonly lessThan = 'lessThan';
		public static readonly greaterThan = 'greaterThan';
		public static readonly startDate = 'startDate';
		public static readonly completedDate = 'completedDate';
	};

	public static readonly validationRules = class {
		public static readonly minimumValueRule = WorkspaceDatabaseKeys.columns.minimumValue;
		public static readonly maximumValueRule = WorkspaceDatabaseKeys.columns.maximumValue;
		public static readonly requiredRule = WorkspaceDatabaseKeys.columns.isColumnNullable;
		public static readonly decimalPlacesRule = WorkspaceDatabaseKeys.columns.decimalPlaces;
		public static readonly maximumLength = WorkspaceDatabaseKeys.columns.width;
		public static readonly intervalBreachRule = WorkspaceDatabaseKeys.tables.isIntervalRelated;
		public static readonly intervalOverlapRule = WorkspaceDatabaseKeys.tables.allowOverlap;
		public static readonly intervalDupRule = WorkspaceDatabaseKeys.tables.allowDups;
		public static readonly intervalGapRule = WorkspaceDatabaseKeys.tables.allowGaps;
		public static readonly startAtZeroRule = WorkspaceDatabaseKeys.tables.dataMustStartAtZero;
		public static readonly externalCreatedRule = WorkspaceDatabaseKeys.columns.externalCreatedRecord;
		public static readonly preventIntervalCorruptionRule = 'prevent_interval_corruption';
		public static readonly originalHasQcRule = 'original_has_qc';
		public static readonly intervalHasChildDataRule = 'child_records_linked';
		public static readonly intervalHasMinorDataRule = 'minor_intervals_linked';
		public static readonly uniquePrimaryKeyRule = 'unique_primary_key';
		public static readonly uniqueComposedPrimaryKeyRule = 'unique_composed_primary_key';
		public static readonly uniqueDeletedPrimaryKeyRule = 'unique_deleted_primary_key';
		public static readonly uniqueDeletedComposedPrimaryKeyRule = 'unique_deleted_composed_primary_key';
		public static readonly uniqueSampleNumberRule = 'unique_sample_number';
		public static readonly uniqueDeletedSampleNumberRule = 'unique_deleted_sample_number';
		public static readonly uniqueStandardNumberRule = 'unique_standard_number';
		public static readonly uniqueDeletedStandardNumberRule = 'unique_deleted_standard_number';
		public static readonly notSupportedCharactersRule = 'not_supported_characters_rule';
	};

	public static crossFieldValidations: { [key: string]: CrossFieldValidation } = {
		// ToDo: add method for extracting pairs
		[WorkspaceDatabaseKeys.columns.depth]: {
			crossFieldName: WorkspaceDatabaseKeys.columns.depth,
			validation: ValidationKeys.validationTypes.noSpecialCharacter
		},
		[WorkspaceDatabaseKeys.columns.depthFrom]: {
			crossFieldName: WorkspaceDatabaseKeys.columns.depthTo,
			validation: ValidationKeys.validationTypes.lessThan
		},
		[WorkspaceDatabaseKeys.columns.depthTo]: {
			crossFieldName: WorkspaceDatabaseKeys.columns.depthFrom,
			validation: ValidationKeys.validationTypes.greaterThan
		},
		[WorkspaceDatabaseKeys.columns.startDate]: {
			crossFieldName: WorkspaceDatabaseKeys.columns.completedDate,
			validation: ValidationKeys.validationTypes.startDate
		},
		[WorkspaceDatabaseKeys.columns.completedDate]: {
			crossFieldName: WorkspaceDatabaseKeys.columns.startDate,
			validation: ValidationKeys.validationTypes.completedDate
		}
	};
}
